import * as actionTypes from '../actions/action-types';

const getInitialState = () => ({
  mainContentFocused: false,
});

const accessibilityReducer = (state = getInitialState(), action) => {
  if (action.type === actionTypes.SET_MAIN_CONTENT_FOCUSED) {
    return {...state, mainContentFocused: action.focused};
  }
  return state;
};

export default accessibilityReducer;
